import React, { useEffect, useState } from 'react';
import { ExoPDFViewer } from './ExoPDFViewer';
import ExoDialog from './ExoDialog';
import Loader from '../special/Loader';
import { DocRender } from 'react-doc-render';
import { Box } from '@mui/material';

// Office document MIME types
const OFFICE_MIME_TYPES = [
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'text/plain',
  'text/csv',
  'application/rtf',
];

const isOfficeMimeType = (mimeType) => {
  return OFFICE_MIME_TYPES.includes(mimeType);
};

export const ExoFilePreview = ({ open, src, onClose, mimeType }) => {
  useEffect(() => {
    checkImageValidity();
  }, [src, open]);

  const [isValidUrl, setIsValidUrl] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  const checkImageValidity = () => {
    if (!open) return;

    // Skip image validation for Office documents
    if (isOfficeMimeType(mimeType)) {
      setIsValidUrl(true);
      setIsChecking(false);
      return;
    }

    const img = new Image();

    img.onload = () => {
      setIsValidUrl(true);
      setIsChecking(false);
    };

    img.onerror = () => {
      setIsValidUrl(false);
      setIsChecking(false);
    };

    img.src = src;
  };

  function handleClose() {
    src = null;
    setIsValidUrl(false);
    setIsChecking(true);
    onClose();
  }

  // Render Office documents with react-doc-render
  if (open && isOfficeMimeType(mimeType)) {
    return (
      <ExoDialog open={open} onClose={handleClose}>
        <Box
          sx={{
            width: '100%',
            height: '80vh',
            minHeight: '500px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <DocRender
            fileUrl={src}
            style={{ width: '100%', height: '100%', border: 'none' }}
          />
        </Box>
      </ExoDialog>
    );
  }

  return (
    <>
      {open &&
        (mimeType === 'application/pdf' ? (
          <ExoPDFViewer open={open} onClose={handleClose} src={src} />
        ) : (
          <ExoDialog open={open} onClose={handleClose}>
            {isChecking && <Loader />}
            {mimeType.split('/')[0] == 'video' ||
            mimeType == 'application/octet-stream' ? (
              <video
                autoplay={'autoplay'}
                src={src}
                alt="preview"
                className={`w-full h-full object-contain ${
                  isValidUrl && isChecking ? 'hidden' : 'block'
                }`}
              />
            ) : (
              (isChecking && <Loader />,
              (
                <img
                  src={src}
                  alt="preview"
                  className={`w-full h-full object-contain ${
                    isValidUrl && isChecking ? 'hidden' : 'block'
                  }`}
                />
              ))
            )}
          </ExoDialog>
        ))}
    </>
  );
};
